import { Flex, FlexProps, Text, Icon, IconProps } from "@chakra-ui/react";
import EtherAmount from "components/EtherAmount";
import EthIcon from "components/EthIcon";
import HoneyIcon from "components/HoneyIcon";
import { BigNumber } from "ethers";
import useCurrency from "hooks/useCurrency";
import { Currency } from "types";

type EtherPriceProps = FlexProps & {
  amount: BigNumber;
  asPrice?: boolean;
  currency?: Currency;
  iconColor?: IconProps["color"];
  iconSize?: IconProps["w"];
};

const EtherPrice = ({
  amount,
  asPrice,
  currency,
  iconColor,
  iconSize,
  ...rest
}: EtherPriceProps) => {
  const currentCurrency = useCurrency();

  return (
    <Flex align="center" gap="0.5" flex="none" {...rest}>
      <Icon
        as={
          (currency || currentCurrency) === Currency.Honey ? HoneyIcon : EthIcon
        }
        color={iconColor}
        w={iconSize}
        h={iconSize}
      />
      <Text>
        <EtherAmount amount={amount} asPrice={asPrice} />
      </Text>
    </Flex>
  );
};

export default EtherPrice;
